<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-filtration-vs"
  [title]="'dashboard.filtrationvs' | translate"
  [content]="
    getButtons()[this.actionStack!.getValue('fvsCModeFonctionnement')].icon!
  "
  [color]="
    getButtons()[this.actionStack!.getValue('fvsCModeFonctionnement')].color!
  "
  [status]="getStatus() | translate"
  [mode]="
    this.actionStack!.getValue('fvsCModeFonctionnement') === 2
      ? P0003601ProgrammeFiltrationAuto[
          this.actionStack!.getValue('fvsCProgrammeFiltrationAuto')
        ].value
      : ''
  "
  [statusMode]="
    getButtons()[this.actionStack!.getValue('fvsCModeFonctionnement')].status!
  "
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
